import UserService from '../service/User';

export const isLogin = () => {
  if (localStorage.getItem('accessToken')) {
    return true;
  } else {
    return false;
  }
};

export const uesrGradeType = async () => {
  const userData = await UserService.userInfo();
  return userData.data.plan_grade;
};
